import styled from 'styled-components';

export const PartnersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`